import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type TenantState = {
  legalEntityId: string | null;
  branchId: string | null;
  setLegalEntityId: (id: string | null) => void;
  setBranchId: (id: string | null) => void;
  clear: () => void;
};

export const useTenantStore = create<TenantState>()(
  persist(
    (set) => ({
      legalEntityId: null,
      branchId: null,
      setLegalEntityId: (id) => set({ legalEntityId: id, branchId: null }),
      setBranchId: (id) => set({ branchId: id }),
      clear: () => set({ legalEntityId: null, branchId: null }),
    }),
    { name: 'creditnow-tenant-context' },
  ),
);
